import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=7ee4f47c"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports